import type { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import NextMapLayer from '../../components/molecules/NextMapLayer';

export interface StateProps {
	playthroughFinished: boolean;
}

export interface DispatchProps {}

export interface OwnProps {
	onFinish: () => void;
}

type Props = StateProps & DispatchProps & OwnProps;

const OverviewScreen: FunctionComponent<Props> = (props: Props) => {
	const { playthroughFinished, onFinish } = props;
	const { t } = useTranslation();

	/**
	 * Animation order:
	 * 1. [after 0 sec for 3 sec] Concept map overlays
	 * 2. [after 2 sec for 2 sec] Score overlays + counter
	 * 3. [after 4 sec for (persona count * 0.3) sec] Persona feedbacks
	 * 4. [after 5 sec for 3 sec] New personas
	 *
	 * |--------|
	 *       |-----|
	 *             |----
	 *                |--------|
	 * 0  1  2  3  4  5  6  7  8  9
	 */
	return (
		<>
			{playthroughFinished ? (
				<NextMapLayer onNext={onFinish} text={t('overview.finish')} />
			) : undefined}
		</>
	);
};

export default OverviewScreen;
